import {
  FETCH_AUDIENCE_SIZE_SUCCESS,
  FETCH_AUDIENCE_SIZE_FAILED,
  CLEAR_AUDIENCE_SIZE_ESTIMATE,
} from 'actions/audienceSizer';

const initialState = {
  hasEstimate: false,
  fetchError: false,
  bucketPercent: -1,
  overflow: false,
  bucket: -1,
};

export default function audienceSizer(state = initialState, action) {
  switch (action.type) {
    case FETCH_AUDIENCE_SIZE_SUCCESS:
      return {
        ...state,
        fetchError: false,
        ...action.payload,
        hasEstimate: true,
      };
    case FETCH_AUDIENCE_SIZE_FAILED:
      return {
        // Note: reset fields
        ...initialState,
        fetchError: true,
      };
    case CLEAR_AUDIENCE_SIZE_ESTIMATE:
      return {
        ...initialState,
      };
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/audienceSizer.js